import { PRESOLD_COUNT, SEED_SALT, TOTAL_NUMBERS } from '../constants/lottery';
import { createRandom, mixSeed, randomInt } from './rng';
import { padNumber } from './draw';

// The 0000–9999 inventory the store sells from. PRESOLD_COUNT of those are
// already taken when a session starts; the rest are free.

const QUICK_PICK_ATTEMPT_FACTOR = 12;

// Partial Fisher–Yates over the full range. Rejection sampling would also
// work at 55% density but has an unbounded tail; this is O(TOTAL_NUMBERS)
// with no retries.
export function buildPresoldSet(sessionSeed) {
    const random = createRandom(mixSeed(sessionSeed, SEED_SALT.INVENTORY));
    const pool = new Uint16Array(TOTAL_NUMBERS);
    for (let i = 0; i < TOTAL_NUMBERS; i += 1) pool[i] = i;

    const presold = new Set();
    for (let i = 0; i < PRESOLD_COUNT; i += 1) {
        const swapWith = i + randomInt(random, TOTAL_NUMBERS - i);
        const picked = pool[swapWith];
        pool[swapWith] = pool[i];
        pool[i] = picked;
        presold.add(picked);
    }
    return presold;
}

// Rejection sampling is the right tool here: `isTaken` is a live predicate
// (pre-sold ∪ purchased ∪ whatever is already in the cart) that no shuffled
// pool can stay in sync with. The attempt cap falls back to a linear scan so
// a nearly-sold-out inventory still returns something.
export function pickAvailableNumbers(random, count, isTaken) {
    const picked = [];
    const chosen = new Set();
    const maxAttempts = count * QUICK_PICK_ATTEMPT_FACTOR;

    for (let attempt = 0; attempt < maxAttempts && picked.length < count; attempt += 1) {
        const candidate = randomInt(random, TOTAL_NUMBERS);
        if (chosen.has(candidate) || isTaken(candidate)) continue;
        chosen.add(candidate);
        picked.push(padNumber(candidate));
    }

    for (let candidate = 0; candidate < TOTAL_NUMBERS && picked.length < count; candidate += 1) {
        if (chosen.has(candidate) || isTaken(candidate)) continue;
        chosen.add(candidate);
        picked.push(padNumber(candidate));
    }

    return picked;
}
